import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { Button } from '~/eds/src/components/Button/Button';
import { usePanelContext } from '~/eds/src/components/Panel/PanelContext';
import { BatchAddGroupNodePayload } from '~/redux/api/methods/group-nodes/types';

import { AddItemsPanel, AddItemsPanelId } from './AddItemsPanel';
import { SelectParentStepProps } from './SelectParentStep';

const messages = defineMessages({
  addItems: {
    id: 'AddItemsButton.addItems',
    defaultMessage: 'Add Items',
    description: 'Button text for adding items to group',
  },
});

export interface AddItemsButtonProps {
  groupId: string;
  rootNodeId?: string;
  onItemsAdded: (payload: BatchAddGroupNodePayload) => void;
  onLoadAllNodes?: SelectParentStepProps['onLoadAllNodes'];
}

export const AddItemsButton = ({
  rootNodeId,
  groupId,
  onItemsAdded,
  onLoadAllNodes,
}: AddItemsButtonProps) => {
  const { formatMessage } = useIntl();
  const { openPanel, closePanel } = usePanelContext();

  const handleOpenPanel = () => {
    openPanel(AddItemsPanelId);
  };

  const handleClosePanel = () => {
    closePanel(AddItemsPanelId);
  };

  return (
    <>
      <Button
        text={formatMessage(messages.addItems)}
        variant="primary"
        onClick={handleOpenPanel}
      />
      <AddItemsPanel
        rootNodeId={rootNodeId}
        groupId={groupId}
        onClose={handleClosePanel}
        onItemsAdded={onItemsAdded}
        onLoadAllNodes={onLoadAllNodes}
      />
    </>
  );
};
